import { Button, DialogClose, InterceptDialog } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import trajectoryActionPlanImage from "@/assets/fr/trajectory-illustrations/trajectoryActionPlan.png";
import { PortalContainerContext, UserContext } from "@/contexts";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

interface UpsellModalProps {
  children: React.ReactNode;
}

const UpsellModalTrajectory = ({ children }: UpsellModalProps) => {
  const { user } = use(UserContext);
  const { container } = use(PortalContainerContext);
  const { t } = useTranslation("trajectory");
  const { sendSegmentEvent } = useSegmentEvent();
  const outboundQueryParamsFreeTrial = useOutboundQueryParams("freetrial");
  const outboundQueryParamsUpgrade = useOutboundQueryParams("upgrade");
  const isStart = user?.company?.subscriptionType === "start";
  const isPause = user?.company?.subscriptionType === "pause";
  const isPro = user?.company?.subscriptionType === "pro";

  return (
    <InterceptDialog
      show={isStart || isPause || isPro}
      title={t("trajectory:trajectoryUpsell.title")}
      description={t("trajectory:trajectoryUpsell.description")}
      warningMessage={
        isStart
          ? t("trajectory:trajectoryUpsell.warningStart")
          : t("trajectory:trajectoryUpsell.warningPro")
      }
      portalContainer={container as Element}
      content={
        <img
          src={trajectoryActionPlanImage}
          alt={t("trajectory:trajectoryUpsell.imageAltText")}
        />
      }
      footer={
        <>
          {isStart && (
            <DialogClose asChild>
              <Button as={Link} to="/pricing" shape="link">
                {t("trajectory:trajectoryUpsell.secondaryCtaStart")}
              </Button>
            </DialogClose>
          )}
          <DialogClose>
            <Button
              as="a"
              href={
                isStart
                  ? `https://try.hellocarbo.com/meetings/emmanuel-watrinet/rdv-abonnement-carbo-entreprise${outboundQueryParamsFreeTrial}`
                  : `https://try.hellocarbo.com/meetings/emmanuel-watrinet/rdv-abonnement-carbo-entreprise${outboundQueryParamsUpgrade}`
              }
              shouldOpenNewTab
              onClick={() =>
                sendSegmentEvent(
                  isStart ? "Subscription Asked" : "clic_CTA_upsell"
                )
              }
            >
              {isStart
                ? t("trajectory:trajectoryUpsell.primaryCtaStart")
                : t("trajectory:trajectoryUpsell.primaryCtaPro")}
            </Button>
          </DialogClose>
        </>
      }
    >
      {children}
    </InterceptDialog>
  );
};

export default UpsellModalTrajectory;
